import React from 'react';
import { Page, Text, View, Document, StyleSheet, Image, PDFViewer } from '@react-pdf/renderer';
import { useLocation } from 'react-router-dom';

const formatNumber = (num) => {
  if (!num || isNaN(num)) return "0";
  return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

function InvoicePdf ({invoiceData})  {
    const location = useLocation();
    // const invoiceData = location.state ? location.state.invoiceData : null;

    if (!invoiceData) {
        return (
            <Text style={{ textAlign: 'center', marginTop: '20px' }}>
                No invoice data available. Please go back and try again.
            </Text>
        );
    }

    return (
        <PDFViewer style={{ width: '100%', height: '100vh' }}>
            <Document>
                <Page size="A4" style={styles.page}>
                    <View style={styles.display}>
                        <View style={{ width: '10%' }}>
                            <Image
                                src={require('../../../assets/img/state-govt-logo.png')}
                                alt="Logo"
                                style={{ width: '100%' }}
                            />
                        </View>
                        <View style={styles.header}>
                            <Text>KANO STATE GOVERNMENT</Text>
                            <View style={styles.subHeader}>
                                <Text>TREASURY BUDGET AND EXPENDITURE ASSURANCE MANAGEMENT SYSTEM (KIFMIS)</Text>
                            </View>
                        </View>
                        <View style={{ width: '10%' }}>
                            <Image
                                src={require('../../../assets/img/state-govt-logo.png')}
                                alt="Logo"
                                style={{ width: '100%' }}
                            />
                        </View>
                    </View>

                    <View style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", lineHeight: 2 }}>
                        <View style={styles.section}>
                            <Text>
                                <Text style={styles.bold}>Invoice Date: </Text>{invoiceData.invoiceDate}
                            </Text>
                            <Text>
                                <Text style={styles.bold}>Invoice No: INV0000106 </Text>
                            </Text>
                            <Text>
                                <Text style={styles.bold}>Economic Code: </Text>{invoiceData.economicCode}
                            </Text>
                            <Text>
                                <Text style={styles.bold}>Account Name:  </Text>{invoiceData.treasuryAccount}
                            </Text>
                            <Text>
                                <Text style={styles.bold}>Invoice for: </Text>{invoiceData.invoiceFor}
                            </Text>
                        </View>
                        < View>
                            <Image
                                src={require("../../../assets/img/katsina.png")}
                                alt="Logo"
                                style={{ width: "50%" }} />
                        </View>
                    </View>

                    {/* Table Section */}
                    <Text style={styles.textBold}>------------------------------------------------------------------------------------------------------------------</Text>
                    <Text style={styles.textBold}>EVIDENCE OF PAYMENT</Text>
                    <Text style={styles.textBold}>------------------------------------------------------------------------------------------------------------------</Text>

                    <View style={styles.table}>
                        <View style={[styles.tableRow, styles.tableHeader]}>
                            <Text style={styles.tableColSmall}>S/N</Text>
                            <Text style={styles.tableColLarge}>DESCRIPTION</Text>
                            <Text style={styles.tableCol}></Text>
                            <Text style={[styles.tableCol, styles.rightAlign]}>AMOUNT</Text>
                        </View>

                        {invoiceData&&invoiceData?.items.map((item, index) => (
                            <View style={styles.tableRow} key={index}>
                                <Text style={styles.tableColSmall}>{index + 1}</Text>
                                <Text style={styles.tableColLarge}>{item?.description}</Text>
                                <Text style={styles.tableCol}></Text>
                                <Text style={[styles.tableCol, styles.rightAlign]}>{formatNumber(item?.amount)}</Text>
                            </View>
                        ))}

                        <View style={[styles.tableRow, styles.tableFooter]}>
                            <Text style={styles.tableColSmall}></Text>
                            <Text style={styles.tableColLarge}>Total Amount</Text>
                            <Text style={styles.tableCol}></Text>
                            <Text style={[styles.tableCol, styles.rightAlign]}>{formatNumber(invoiceData?.totalAmount)}</Text>
                        </View>
                    </View>

                    <View style={styles.footer}>
                        <Text>Please Retain Your Invoice</Text>
                        <Text>Thank You</Text>
                        <Text>Powered by KATSINA STATE GOVERNMENT</Text>
                        <Text>Developed by BRAINSTORM IT SOLUTIONS</Text>
                    </View>
                </Page>

                {/* Page 2: Invoice Example */}
                <Page size="A4" style={styles.page}>
                    {/* Header Section */}
                    <View style={styles.display}>
                        <View style={{ width: '10%' }}>
                            <Image
                                src={require('../../../assets/img/state-govt-logo.png')}
                                alt="Logo"
                                style={{ width: '100%' }}
                            />
                        </View>
                        <View style={styles.header}>
                            <Text>KANO STATE INTERNAL REVENUE SERVICE</Text>
                            <View style={styles.subHeader}>
                                <Text>TREASURY BUDGET AND EXPENDITURE ASSURANCE MANAGEMENT SYSTEM (KIFMIS)</Text>
                            </View>
                        </View>
                        <View style={{ width: '10%' }}>
                            <Image
                                src={require('../../../assets/img/state-govt-logo.png')}
                                alt="Logo"
                                style={{ width: '100%' }}
                            />
                        </View>
                    </View>

                    {/* Invoice Details */}
                    <View style={styles.row}>
                        <Text>Receipt No: 2021-001</Text>
                        <Text>Receipt Date: 03.01.2021</Text>
                        <Text>Due Date: 03.15.2021</Text>
                    </View>

                    {/* Invoice Table */}
                    <View style={styles.table}>
                    {invoiceData&&invoiceData?.items.map((item, index) => (
                        <View style={[styles.tableRow, styles.tableHeader]}>
                            <Text style={styles.tableColLarge}>DESCRIPTION</Text>
                            <Text style={styles.tableColLarge}>{item?.description}</Text>
                            <Text style={[styles.tableCol, styles.rightAlign]}>AMOUNT</Text>
                        </View>
                    ))}
                        <View style={[styles.tableRow, styles.tableFooter]}>
                            <Text style={styles.tableColLarge}>Total Amount</Text>
                            <Text style={styles.tableCol}></Text>
                            <Text style={[styles.tableCol, styles.rightAlign]}>{formatNumber(invoiceData?.totalAmount)}</Text>
                        </View>
                    </View>

                    <View style={styles.footer}>
                        <Text>Please Retain Your Receipt</Text>
                        <Text>Thank You</Text>
                        <Text>Powered by KATSINA STATE GOVERNMENT</Text>
                        <Text>Developed by BRAINSTORM IT SOLUTIONS</Text>
                    </View>
                </Page>
            </Document>
        </PDFViewer>
    );
};

export default InvoicePdf;

const styles = StyleSheet.create({
    page: {
        padding: 30,
        fontSize: 10,
        fontFamily: 'Helvetica',
        lineHeight: 1.5,
    },
    display: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    textBold: {
        textAlign: "center",
        fontSize: 14,
        fontWeight: "bold",
    },
    header: {
        textAlign: "center",
        fontSize: 14,
        marginBottom : 10,
        fontWeight: "bold",
        textTransform: "uppercase",
        width: "100%"
    },
    subHeader: {
        textAlign: "center",
        fontSize: 10,
        marginBottom: 10,
        width: "100%"
    },
    row: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        marginVertical: 10,
    },
    columnHalf: {
        width: '48%',
    },
    table: {
        display: 'table',
        width: "100%",
        marginVertical: 10,
        borderStyle: "solid",
        borderColor: "#000",
        borderWidth: 1,
        lineHeight: 2.5,
    },
    tableRow: {
        flexDirection: 'row',
        borderBottomWidth: 1,
        borderColor: '#000',
    },
    tableHeader: {
        backgroundColor: '#f0f0f0',
        fontWeight: 'bold',
    },
    tableCol: {
        lineHeight: 1.5,
        padding: 5,
        width: '25%',
        textAlign: 'left',
        borderRightWidth: 1,
        borderColor: '#000',
    },
    tableColLarge: {
        width: '50%',
        padding: 5,
        textAlign: 'left',
        borderRightWidth: 1,
        borderColor: '#000',
    },
    tableColSmall: {
        width: '15%',
        padding: 5,
        textAlign: 'left',
        borderRightWidth: 1,
        borderColor: '#000',
    },
    tableFooter: {
        borderTopWidth: 1,
        borderColor: '#000',
    },
    footer: {
        textAlign: 'center',
        marginTop: 20,
        fontSize: 8,
    },
    footerText: {
        textAlign: 'center',
    },
    rightAlign: {
        textAlign: 'right',
    },
});